/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_Add_ChildInputs */

const vi_lot_items_split_add_child = /** @type {(inputs: Lot_Items_Split_Add_ChildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô con`)
};

/**

* @param {Lot_Items_Split_Add_ChildInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_add_child = /** @type {((inputs?: Lot_Items_Split_Add_ChildInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_Add_ChildInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_add_child(inputs)
});